import { render, staticRenderFns } from "./px-steps.vue?vue&type=template&id=7aef58ee&scoped=true&"
import script from "./px-steps.vue?vue&type=script&lang=ts&"
export * from "./px-steps.vue?vue&type=script&lang=ts&"
import style0 from "./px-steps.vue?vue&type=style&index=0&id=7aef58ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aef58ee",
  null
  
)

export default component.exports